import moment from "moment";
import { getLoggedinUser } from "../../userStore";
import { FaCircle } from "react-icons/fa6";
import { getBaseUrl } from "../../utils/common_lib";

export const NO_CAREPLAN_PROGRAM = {
  slug: "no_careplan",
  title: "No careplan",
};

export const LEGACY_CAREPLAN_ENABLED = false;

export const TAB_SEGMENT_KEYS = {
  problems: ["problems"],
  visit_frequencies: ["visit_frequencies"],
  allergies: ["allergies"],
  medication: ["medications"],
  trackers: ["trackers"],
  goals: ["goals"],
  barriers: ["barriers"],
  interventions: ["labs", "radiology", "education", "other_interventions"],
  support: ["support"],
  screening: ["screenings"],
  events: ["events"],
  guidelines: ["guidelines"],
};

export const isCarePlanTabAvailable = (tabType, segments) => {
  const keys = TAB_SEGMENT_KEYS[tabType];
  if (!keys?.length) {
    return false;
  }
  return keys.some((key) => segments?.some((segment) => segment.key === key));
};

export const getCarePlanSegment = (segments, key, fallback = []) => {
  const segment = segments?.find((item) => item.key === key);
  const data = segment?.data;

  if (data == null || data === "") {
    return fallback;
  }

  if (key === "support") {
    return data && typeof data === "object" && !Array.isArray(data) ? data : fallback;
  }

  return Array.isArray(data) ? data : fallback;
};

export const getApiErrorMessage = (error, response, fallback) => {
  if (response?.msg && response?.code !== 0) {
    return response.msg;
  }
  if (typeof error === "string") {
    return error;
  }
  if (error?.data?.msg) {
    return error.data.msg;
  }
  if (error?.message) {
    return error.message;
  }
  return fallback;
};

export const getFileUrl = (uuid) => {
  const user = getLoggedinUser();
  let url = "";
  url += getBaseUrl()+ "/efax/read_document/";
  url += "?file_name=" + uuid || "";
  url += "&token=" + user.token;
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
};
export const CarePlanTabs = [
  {
    title: "Problems",
    type: "problems",
    active: false,
  },
  {
    title: "Visit Frequencies",
    type: "visit_frequencies",
    active: false,
  },
  {
    title: "Allergies",
    type: "allergies",
    active: false,
  },
  {
    title: "Medication",
    type: "medication",
    active: false,
  },
  {
    title: "Trackers",
    type: "trackers",
    active: false,
  },
  {
    title: "Goals",
    type: "goals",
    active: false,
  },
  {
    title: "Barriers",
    type: "barriers",
    active: false,
  },
  {
    title: "Interventions",
    type: "interventions",
    active: false,
  },
  {
    title: "Support",
    type: "support",
    active: false,
  },
  {
    title: "Screening",
    type: "screening",
    active: false,
  },
  {
    title: "Events",
    type: "events",
    active: false,
  },
  {
    title: "Guidelines",
    type: "guidelines",
    active: false,
  },
];

export const barriersCols = [
  {
    title: "Barriers",
    key: "title",
    getData: (item) =>
      item?.title ? (
        <span className="text-black text-sm flex flex-row gap-x-2">
          <FaCircle size={10} className="text-orange-500 text-sm mt-1" />
          {item?.title}
        </span>
      ) : (
        "-"
      ),
  },
  { title: "Health Conditions", key: "health_conditions_name" },
  { title: "By", key: "created_by" },
  {
    title: "Date",
    key: "created",
    getData: (data) => {
      const originalDate =
        data?.created != "" ? moment(data?.created).format("l") : "";
      return originalDate;
    },
  },
];
///Support Cols///
export const supportContactCols = [
  {
    title: "Name",
    key: "full_name",
    getData: (item) =>
      item?.fname ? (
        <div>
          {item?.title} {item?.suffix}
        </div>
      ) : (
        "-"
      ),
  },
  { title: "Type", key: "address_type_title" },
  { title: "Relationship", key: "relationship_title" },
  {
    title: "Phone",
    key: "phone",
    getData: (item) =>
      item?.phone ? (
        <div>
          {item?.phone?.mobile ||
            item?.phone?.home ||
            item?.phone?.work ||
            item?.phone?.phone}
        </div>
      ) : (
        "-"
      ),
  },

  {
    title: "Address",
    key: "address_line1",
    getData: (item) =>
      item?.address_line1 ? (
        <div>
          {item?.address_line1} {`${item?.city && "," + item?.city}`}{" "}
          {`${item?.state && "," + item?.state}`}{" "}
          {`${item?.zip && "," + item?.zip}`}
        </div>
      ) : (
        "-"
      ),
  },
];
export const supportProviderCols = [
  {
    title: "Name",
    key: "fname",
    getData: (item) =>
      item?.fname ? (
        <div>
          {item?.title} {item?.suffix}
        </div>
      ) : (
        "-"
      ),
  },
  {
    title: "Address",
    key: "street",
    getData: (item) =>
      item?.street ? (
        <div>
          {item?.street} {`${item?.city && "," + item?.city}`}{" "}
          {`${item?.state && "," + item?.state}`}{" "}
          {`${item?.zip && "," + item?.zip}`}
        </div>
      ) : (
        "-"
      ),
  },
  { title: "Specialty", key: "specialty_title" },
  { title: "NPI", key: "npi" },
  {
    title: "Phone",
    key: "phone",
    getData: (item) =>
      item ? (
        <div>
          {item?.mobile ||
            item?.home ||
            item?.work ||
            item?.phone}
        </div>
      ) : (
        "-"
      ),
  },
];
export const supportSupplierCols = [
  { title: "Name", key: "name" },
  { title: "Services / Product", key: "service_product" },
  { title: "Comments", key: "comments" },
];
//screening cols
// export const screeningCols = [
//   {
//     title: "Name",
//     key: "ScreeningType",
//     getData: (item) =>
//       item?.ScreeningType ? <div>{item?.ScreeningType?.name}</div> : "-",
//   },
//   {
//     title: "Frequency",
//     key: "frequency",
//     getData: (item) =>
//       item?.frequency ? (
//         <div>
//           {item?.frequency?.type} {" "}{`${
//             item?.frequency?.time &&
//             "- " + item?.frequency?.time.replace(/~/g, " ")
//           }`}
//         </div>
//       ) : (
//         "-"
//       ),
//   },
//   { title: "Problems", key: "health_conditions_name",
//   getData: (item) =>{
//     var formattedString = item?.health_conditions_name != '' ? item?.health_conditions_name.split("~") : []
//     return (<ul className="list-disc flex flex-col">
//       {formattedString?.map((v)=>(
//             <li>{v}</li>
//           ))}
//           </ul>)
//       } },
// ];

//psycho-social cols
export const psychoSocialCols = [
  {
    title: "Name",
    key: "ScreeningType",
    getData: (item) =>
      item?.ScreeningType ? <div>{item?.ScreeningType?.name}</div> : "-",
  },
  {
    title: "Frequency",
    key: "frequency",
    getData: (item) =>
      item?.frequency ? (
        <div>
          {item?.frequency?.type}
            {" "}{`${
              item?.frequency?.time &&
              "- " + item?.frequency?.time.replace(/~/g, " ")
            }`}
        </div>
      ) : (
        "-"
      ),
  },
  { title: "Problems", key: "health_conditions_name",
  getData: (item) =>{
    var formattedString = item?.health_conditions_name != '' ? item?.health_conditions_name.split("~") : []
    return (<ul className="list-disc flex flex-col">
      {formattedString?.map((v)=>(
            <li>{v}</li>
          ))}
          </ul>)
      }
   },
];
export const eventCols = [
  { title: "Event Info", key: "name" },
  {
    title: "Reminder",
    key: "reminder_date",
    getData: (data) => {
      const originalDate =
        data?.reminder_date != ""
          ? moment(data?.reminder_date).format("l")
          : "";
      return originalDate;
    },
  },

  {
    title: "Frequency",
    key: "frequency",
    getData: (item) =>
      item?.frequency ? (
        <div>
          {item?.frequency?.type}{" "}
          {`${
            item?.frequency?.time &&
            "- " + item?.frequency?.time.replace(/~/g, " ")
          }`}
        </div>
      ) : (
        "-"
      ),
  },

  { title: "Problems", key: "health_conditions_name",
  getData: (item) =>{
    
    var formattedString = item?.health_conditions_name != '' ? item?.health_conditions_name.split("~") : []
    return (
    <ul className="list-disc flex flex-col">
      {formattedString?.map((v)=>(
            <li>{v}</li>
          ))}
          </ul>
        
          )
      }
   },
];

//Guidelines Cols
export const guidelinesCols = [
  { title: "Guideline", key: "guidelines" },
  { title: "Type", key: "ccm_type" },
  { title: "Problems", key: "health_conditions_name",
  getData: (item) =>{
    var formattedString = item?.health_conditions_name != '' ? item?.health_conditions_name.split("~") : []
    return (<ul className="list-disc flex flex-col">
      {formattedString?.map((v)=>(
            <li>{v}</li>
          ))}
          </ul>)
      }
   },
];
// intervantions radiology cols

export const intervationsRadiologyCols = [
  {
    title: "Date",
    key: "datetime",
    getData: (data) => {
      const originalDate =
        data?.datetime != "" ? moment(data?.datetime).format("l") : "";
      return originalDate;
    },
  },
  { title: "Order #", key: "order_number" },
  { title: "Radiology Practice", key: "radiology_practice_name" },
  { title: "Provider", key: "ordering_provider_name" },
  { title: "Assigned To", key: "assigned_to_name" },
  { title: "Status", key: "status_text" },
];
// intervantions education cols
export const intervationsEducationCols = [
  {
    title: "Date",
    key: "datetime",
    getData: (data) => {
      const originalDate =
        data?.datetime != "" ? moment(data?.datetime).format("l") : "";
      return originalDate;
    },
  },
  { title: "Provider", key: "ordering_provider_name" },
  {
    title: "Links",
    key: "education_data",
    getData: (item) =>
      item?.education_data ? (
        <div>
          {item?.education_data?.map((v) => {
            return (
              <a
                className="flex flex-col text-blue-500 hover:underline cursor-pointer"
                href={v.link}
                target="_blank"
              >
                {v.title}
              </a>
            );
          })}
        </div>
      ) : (
        "-"
      ),
  },
];
//interventions Other Cols//
export const interventionsOtherCols = [
  { title: "Details", key: "details" },
  { title: "Problems", key: "health_conditions_name" },
  {
    title: "Updated by",
    key: "updated_by_name",
    getData: (item) =>
      item ? (
        <div>
          {item?.updated_by_name} {moment(item?.updated).format("l hh:mm A")}
        </div>
      ) : (
        "-"
      ),
  },
];
